<template>
  <div ref="mobileMenu" class="relative z-[60] hidden" aria-labelledby="mobile-menu-title" role="dialog"
    aria-modal="true">
    <!-- 背景遮罩 -->
    <div ref="mobileMenuBackdrop"
      class="fixed inset-0 transition-opacity duration-300 ease-in-out opacity-0 bg-black/40 backdrop-blur-sm"
      @click="$emit('menu-action', false)"></div>

    <div class="fixed inset-0 overflow-hidden pointer-events-none">
      <div class="absolute inset-0 overflow-hidden">
        <div class="fixed inset-y-0 left-0 flex max-w-full pr-10 pointer-events-none">
          <!-- Drawer Panel -->
          <div ref="mobileMenuPanel"
            class="flex flex-col w-screen h-full max-w-xs transition-transform duration-300 ease-in-out transform -translate-x-full bg-white shadow-2xl pointer-events-auto">
            <!-- 1. Header (Logo & Close) -->
            <div class="flex items-center justify-between px-6 py-5 border-b border-gray-100">
              <h2 class="text-xl font-bold tracking-tight text-black">
                <router-link to="/" @click.native="$emit('menu-action', false)" class="z-10 flex items-center h-full ">
                  <img src="/img/logo.webp" :alt="$GetColumn('brand_name')" class="block h-[30px] w-auto" />
                </router-link>
              </h2>
              <button @click="$emit('menu-action', false)" class="text-gray-400 transition-colors hover:text-black">
                <span class="sr-only">Close menu</span>
                <svg class="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <!-- 2. Body (Links) -->
            <div class="flex-1 px-4 py-6 overflow-y-auto no-scrollbar">
              <!-- Search Bar -->
              <div class="relative mb-8">
                <input type="text" placeholder="搜尋商品..." v-model="keyword"
                  @change="$router.push(`/collections?keyword=${keyword}`), keyword = '', $emit('menu-action', false)"
                  class="w-full bg-gray-50 border border-gray-200 rounded-lg py-2.5 pl-10 pr-4 text-sm focus:outline-none focus:border-black transition-colors" />
                <svg class="absolute w-4 h-4 text-gray-400 -translate-y-1/2 left-3 top-1/2" fill="none"
                  stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"></path>
                </svg>
              </div>

              <!-- Main Nav -->
              <nav class="space-y-1">
                <router-link to="/collections" @click.native="$emit('menu-action', false)"
                  class="block px-3 py-3 text-base font-medium text-gray-900 transition-colors rounded-lg hover:bg-gray-50">所有商品</router-link>
                <router-link to="/news" @click.native="$emit('menu-action', false)"
                  class="block px-3 py-3 text-base font-medium text-gray-900 transition-colors rounded-lg hover:bg-gray-50">最新消息</router-link>
                <router-link to="/contact" @click.native="$emit('menu-action', false)"
                  class="block px-3 py-3 text-base font-medium text-gray-900 transition-colors rounded-lg hover:bg-gray-50">聯絡我們</router-link>
              </nav>

              <!-- User Links -->
              <div class="pt-8 mt-8 border-t border-gray-100">
                <h3 class="px-3 mb-2 text-xs font-semibold tracking-wider text-gray-400 uppercase">
                  會員專區
                </h3>
                <nav class="space-y-1">
                  <router-link to="/account/login" @click.native="$emit('menu-action', false)"
                    class="flex items-center gap-3 px-3 py-3 text-base font-medium text-gray-600 transition-colors rounded-lg hover:bg-gray-50 hover:text-black">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                    </svg>
                    會員中心 / 登入
                  </router-link>
                  <router-link to="/order_search/search" @click.native="$emit('menu-action', false)"
                    class="flex items-center gap-3 px-3 py-3 text-base font-medium text-gray-600 transition-colors rounded-lg hover:bg-gray-50 hover:text-black">
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2">
                      </path>
                    </svg>
                    訂單查詢
                  </router-link>
                </nav>
              </div>
            </div>

            <!-- 3. Footer (Social) -->
            <div class="px-6 py-6 border-t border-gray-100 bg-gray-50">
              <div class="flex justify-center gap-4">
                <a :href="$GetColumn('company_facebook')" target="_blank"
                  class="text-gray-400 transition-colors hover:text-black"><svg class="w-5 h-5" fill="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg></a>
                <a :href="$GetColumn('company_instagram')" target="_blank"
                  class="text-gray-400 transition-colors hover:text-black">

                  <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path
                      d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z">
                    </path>
                  </svg>
                </a>
                <a :href="$GetColumn('company_line')" target="_blank"
                  class="text-gray-400 transition-colors hover:text-black"><svg class="w-5 h-5" fill="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.104.495.254l2.495 3.415V8.108c0-.345.282-.63.63-.63.345 0 .627.285.627.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.627-.63.349 0 .631.285.631.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.282.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.259 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314">
                    </path>
                  </svg></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getLocalStorage } from "@/common/cookie";
export default {
  name: "MainMenu",
  props: {
    menu_status: {
      require: true,
      type: Boolean,
    },
  },
  data() {
    return {
      menu_list: [
        {
          title: "商品列表",
          sub_title: "Products",
          link: "/collections",
        },
        // {
        //   title: "關於我們",
        //   sub_title: "About Us",
        //   link: "/about",
        // },
        {
          title: "最新消息",
          sub_title: "News",
          link: "/news",
        },
        // {
        //   title: "影音專區",
        //   sub_title: "Videos",
        //   link: "/video",
        // },
        {
          title: "聯絡我們",
          sub_title: "Contact",
          link: "/contact",
        },
      ],
      keyword: "",
    };
  },
  methods: {
    OpenSearchDialog() {
      this.$emit("menu-action", false);
      this.$store.commit("SetSearchDialog", true);
    },
    OpenMenu() {
      const mobileMenu = this.$refs.mobileMenu;
      const mobileMenuBackdrop = this.$refs.mobileMenuBackdrop;
      const mobileMenuPanel = this.$refs.mobileMenuPanel;

      mobileMenu.classList.remove('hidden');

      // 禁止背景捲動
      document.body.style.overflow = 'hidden';

      // 動畫效果 (Fade In & Slide In)
      setTimeout(() => {
        mobileMenuBackdrop.classList.remove('opacity-0');
        mobileMenuPanel.classList.remove('-translate-x-full');
      }, 10);
    },
    CloseMenu() {
      const mobileMenu = this.$refs.mobileMenu;
      const mobileMenuBackdrop = this.$refs.mobileMenuBackdrop;
      const mobileMenuPanel = this.$refs.mobileMenuPanel;
      // 動畫效果 (Fade Out & Slide Out)
      mobileMenuBackdrop.classList.add('opacity-0');
      mobileMenuPanel.classList.add('-translate-x-full');

      // 恢復背景捲動
      document.body.style.overflow = '';

      // 等待動畫結束後隱藏元素
      setTimeout(() => {
        mobileMenu.classList.add('hidden');
      }, 300);
    }
  },
  watch: {
    menu_status() {
      if (this.menu_status) {
        this.OpenMenu();
      } else {
        this.CloseMenu();
      }
    },
  },
  computed: {
    // 是否登入會員
    is_member() {
      return getLocalStorage("account_token");
    },
  },
};
</script>
